'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { Button } from '@/components/ui'

/**
 * Error boundary for product page
 * Catches runtime errors and displays fallback UI
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to console — no external error tracking
    console.error('Product page error:', error)
  }, [error])

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <div className="max-w-md mx-auto space-y-6">
        <h2 className="text-2xl font-bold text-text-primary">
          Something went wrong
        </h2>
        <p className="text-text-secondary">
          An error occurred while loading the product. Try refreshing the page or
          return to the catalog.
        </p>
        <div className="flex gap-3 justify-center">
          <Button onClick={reset} variant="primary">
            Try again
          </Button>
          <Button asChild variant="secondary">
            <Link href="/shop">Browse catalog</Link>
          </Button>
        </div>
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-8 text-left">
            <summary className="cursor-pointer text-sm text-text-secondary hover:text-primary">
              Error details (dev only)
            </summary>
            <pre className="mt-2 p-4 bg-surface rounded-md text-xs overflow-auto">
              {error.message}
            </pre>
          </details>
        )}
      </div>
    </div>
  )
}
